var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-progress',{staticClass:"tw-w-full tw-rounded-full tw-overflow-hidden",attrs:{"percentage":_vm.progress,"color":_vm.progressColor,"show-text":_vm.noCaption}})}
var staticRenderFns = []

export { render, staticRenderFns }